import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SerialUser } from '../models/serialUser.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SerialUserService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public postInsertSerialUser(item: SerialUser): Observable<SerialUser> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/insertSerialUser`,
      item,
      { withCredentials: true }
    );
  }

  public updateInsertSerialUser(item: SerialUser, id: Number): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/updateSerialUser/${id}`,
      item,
      { withCredentials: true }
    );
  }

  public deleteSerialUser(id: number): Observable<String> {
    return this.http.get<String>(
      `${this.apiServerUrl}/api/v1/deleteSerialUser/${id}`
    );
  }

  public getSerialUser(userId: number): Observable<SerialUser[]> {
    return this.http.get<SerialUser[]>(
      `${this.apiServerUrl}/api/v1/getSerialUser/${userId}`
    );
  }
}
